"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceNameForSession = void 0;
const _1 = require(".");
/**
 * Return device name from "{@link https://healthcareinc.atlassian.net/wiki/spaces/REPORTING/pages/107675730/IV+Parameter+structure|IV Parameter}"
 * or based on screen width as fallback.
 *
 * @param {string} iv - A valid iv parameter string.
 *
 * @returns {string} The device value.
 */
function getDeviceNameForSession(iv) {
    return (0, _1.getDeviceFromIv)(iv) || (0, _1.getDeviceByViewportWidth)();
}
exports.getDeviceNameForSession = getDeviceNameForSession;
//# sourceMappingURL=get-device-name-for-session.js.map